<template>
  <div>
    <CreativeRow
      v-for="id in creativesIds"
      :key="id"
      :creative-id="id"
      :show-delete="showDelete"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import CreativeRow from './CreativeRow.vue'

export default defineComponent({
  name: 'CreativesList',
  components: {
    CreativeRow
  },
  props: {
    creativesIds: {
      type: Array,
      required: true
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  }
})
</script>
